import type { ExecutionCommentView } from '@testflow/shared';
import type { RunHistoryEntry } from '../../lib/plans-api.js';

export type TimelineItem =
  | { kind: 'run'; at: string; run: RunHistoryEntry }
  | { kind: 'comment'; at: string; comment: ExecutionCommentView };

// #193: Läufe und Kommentare zeitlich gemischt, neueste zuerst. Der Kommentar hängt nicht an einem
// Lauf, sondern an Plan + Testfall — seine Stelle in der Historie ergibt sich allein aus dem
// Zeitstempel. Verglichen wird der Zeitpunkt (ms), nicht der String. Gleichstand: Lauf vor
// Kommentar — das ist nur die Anzeigereihenfolge, passend zur SQL-Regel „Gleichstand = gesperrt“;
// ob ein Kommentar aktuell oder gesperrt ist, entscheidet allein die API (`current`).
export function buildRunTimeline(
  runs: RunHistoryEntry[],
  comments: ExecutionCommentView[],
): TimelineItem[] {
  const items: (TimelineItem & { ms: number; rank: number })[] = [
    ...runs.map((run) => ({
      kind: 'run' as const,
      at: run.executed_at,
      run,
      ms: Date.parse(run.executed_at),
      rank: 0,
    })),
    ...comments.map((comment) => ({
      kind: 'comment' as const,
      at: comment.created_at,
      comment,
      ms: Date.parse(comment.created_at),
      rank: 1,
    })),
  ];
  // Absteigend nach Zeit; bei Gleichstand der kleinere Rang (Lauf) zuerst. Array.sort ist stabil.
  items.sort((a, b) => b.ms - a.ms || a.rank - b.rank);
  return items.map(({ ms: _ms, rank: _rank, ...item }) => item as TimelineItem);
}
